import api from '../common/api/licenseApi';

const basePath = '/licenses';

export default {
  getList(params = {limit:200}) {
    return api.get(basePath, { params });
  },
  create(license) {
    return api.post(`${basePath}`, license);
  },
  get(licenseId, params = {}) {
    return api.get(`${basePath}/${licenseId}`, { params });
  },
  update(licenseId, license) {
    return api.put(`${basePath}/${licenseId}`, license);
  }
};



// WEBPACK FOOTER //
// ./src/services/licenseService.js